import { h } from "../../../_snowpack/pkg/preact.js";
export const RefreshButton = ({
  onClick
}) => {
  return h("button", {
    className: "uiButton nudgeDown",
    tabIndex: 0,
    onClick: onClick
  }, "new world");
};